import request from '@Sys~/api/request'
import { apiUrl, type } from './env'
import store from '@Sys~/store'

const gateUrl = apiUrl.gateUrl

function ajax_fn(url, data, method, header) {
  header.header_username = encodeURI(store.getters.realName); // realName

  return request({
    headers: header,
    baseURL: gateUrl,
    url: url,
    method: method,
    params: method == 'GET'? data : '',
    data: method != 'GET' ? data : '',
    withCredentials: false
  })
}

//元数据管理模块
//获取元数据列表
export function queryBy_searchForm(data) {
  return ajax_fn("/table/selectList", data, "GET", {})
}
//批量同步权限点
export function update_batchSync(data) {
  return ajax_fn("/table/batchSyncPower", data, "post", {})
}
//同步元数据
export function sync_metaData(data) {
  return ajax_fn("/table/handSyncTable", data, "post", {})
}
//根据表单新增
export function create_byForm(data) {
  return ajax_fn("/table/addTableByForm/"+data.dataSourceType, data, "post", {})
}
//根据ddl新增
export function create_byDdl(data) {
  return ajax_fn("/table/addTableByDDL/"+data.dataSourceType, data, "post", {})
}
//查看某条数据
export function queryBy_datas(data) {
  return ajax_fn("/table/selectMetaTableById/"+data, {}, "GET", {})
}
//查看全部标签
export function queryLabelBy(data) {
  return ajax_fn("/label/all", {}, "GET", {})
}
//查看全部创建人
export function queryCreateUserBy(data) {
  return ajax_fn("/table/getCreateUserIds", {}, "GET", {})
}
//删除某条数据
export function deleteBy_datas(data) {
  return ajax_fn("/table/deleteTableById/"+data, {}, "post", {})
}
//根据ddl修改
export function update_byDdl(data) {
  return ajax_fn("/table/updateTableByDDL/"+data.dataSourceType, data, "post", {})
}
//根据表单修改
export function update_byForm(data) {
  return ajax_fn("/table/updateTableByForm/"+data.dataSourceType, data, "post", {})
}
//获取数据源类型
export function queryBy_dbtype(data) {
  return ajax_fn("/datasource/getDataSourceByType/"+data, data, "GET", {})
}
//获取数据库信息
export function queryBy_md5Id(data) {
  return ajax_fn("/datasource/getDataBaseByDataSourceId/"+data, data, "GET", {})
}
//操作上线状态
export function update_onlineStatus(data) {
  return ajax_fn("/table/updateOnlineStatus?id="+data.id+'&status='+data.status, data, "POST", {})
}
//操作同步
export function update_Sync(data) {
  return ajax_fn("table/syncTable/"+data.md5Id, data, "POST", {})
}
//编辑标签
export function update_label(data) {
  return ajax_fn("table/bindLabel", data, "POST", {})
}
//编辑更新频率
export function update_frequency(data){
  return ajax_fn("table/updateUpdateFrequencyByTableMd5Id", data, "POST", {})
}
//新增文件上传数据
export function add_file(data) {
  return ajax_fn("/table/saveTableByCSV", data, "POST", {})
}
//文件上传数据源下拉
export function datasource_select(data) {
  return ajax_fn("/datasource/listByCsvImport", data, "GET", {})
}
//文件上传查看保存
export function look_file(data) {
  return ajax_fn("/table/updateEffectTimeAndLabel", data, "POST", {})
}
//文件上传更新数据
export function edit_file(data) {
  return ajax_fn("/table/updateTableByCSV", data, "POST", {})
}






// 下载
export function download_export(data,url) {
  var form = document.createElement("form");
  form.style.display = "none";
  form.action = gateUrl + url;
  form.method = "post";
  document.body.appendChild(form);

  for (var key in data) {
    if (key == "params") {
      for (var keys in data.params) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "params[" + keys + "]";
        input.value = data.params[keys];
        form.appendChild(input);
      }
    } else {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }
  }
  console.log(form)
  form.submit();
  form.remove();
}
